<template>
  <div :class="classes">
    <div class="trbo-a-layout__wrapper">
      <div class="trbo-a-layout__header">
        <question-header
          :settings="settings.header"
          @restart="onRestart"
          @go-to-landing-page="onGoToLandingPage"
          @progress-bar-item-click="onProgressBarItemClick"
          @search="onSearch"
          @link-from-message-click="onClickLinkFromMessage"
        />
      </div>
      <div class="trbo-a-layout__content">
        <slot />
      </div>
      <div :class="footerClasses">
        <page-footer
          @prev="onPrev"
          @next="onNext"
          @skip="onSkip"
          @load-more-products="onLoadMoreProducts"
        />
      </div>
      <notification
        v-if="hasNotification"
        :type="notification.type"
        :message="notification.message"
        @close="clearNotification"
      />
    </div>
  </div>
</template>

<script>
// @flow

import { mapActions, mapState } from 'vuex'

import QuestionHeader from '../QuestionHeader/QuestionHeader.vue'
import PageFooter from '../PageFooter/PageFooter.vue'
import Notification from '../../Notification/Notification.vue'

export default {
  components: {
    QuestionHeader,
    PageFooter,
    Notification
  },
  props: {
    settings: {
      type: Object, // QuestionSettings
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    customClassName: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState(['scrollDirection', 'notification', 'isEmbedded']),
    classes () {
      return {
        'trbo-a-layout': true,
        'trbo-a-layout--is-loading': this.isLoading,
        'trbo-a-layout--is-embedded': this.isEmbedded,
        [this.customClassName]: !!this.customClassName
      }
    },
    footerClasses () {
      return {
        'trbo-a-layout__footer': true,
        'trbo-a-layout__footer--is-hidden': this.scrollDirection === 'down'
      }
    },
    hasNotification () {
      return !!this.notification
    }
  },
  methods: {
    ...mapActions(['setNotification']),
    onRestart (): void {
      this.$emit('restart')
    },
    onGoToLandingPage (): void {
      this.$emit('go-to-landing-page')
    },
    onPrev (): void {
      this.$emit('prev')
    },
    onNext (): void {
      this.$emit('next')
    },
    onSkip (): void {
      this.$emit('skip')
    },
    onLoadMoreProducts (): void {
      this.$emit('load-more-products')
    },
    onProgressBarItemClick (payload): void {
      this.$emit('progress-bar-item-click', payload)
    },
    clearNotification (): void {
      this.setNotification(null)
    },
    onSearch (query: string): void {
      this.$emit('search', query)
    },
    onClickLinkFromMessage (url: string): void {
      this.$emit('link-from-message-click', url)
    }
  }
}
</script>

<style scoped src="./layout.scss" />
